
const api_url = "https://okiya.ziz.co.ke";

export default api_url;